const DIALOGUE_TASK_ENTRY_KEY = 'icbt-dialogue-task-entry';

export function markDialogueTaskEntry() {
  window.sessionStorage.setItem(DIALOGUE_TASK_ENTRY_KEY, '1');
}

export function clearDialogueTaskEntry() {
  window.sessionStorage.removeItem(DIALOGUE_TASK_ENTRY_KEY);
}

export function returnFromTask(router) {
  if (window.sessionStorage.getItem(DIALOGUE_TASK_ENTRY_KEY) === '1') {
    clearDialogueTaskEntry();
    router.replace('/layout/dialogue');
    return;
  }
  router.go(-1);
}
